import RangeView from './rangeView';

export default class DistanceRangeView extends RangeView {
    currentValueEl;

    constructor(rangeElId, currentValue, endValue) {
        super(rangeElId, currentValue, endValue);

        [this.currentValueEl] = this.rangeEl.getElementsByClassName('current-value');
        this.updateInnerHTML(this.rangeEl.getElementsByClassName('end-value')[0], endValue);
        this.updateCurrentValue();
    }

    updateCurrentValue() {
        this.updateInnerHTML(this.currentValueEl, this.currentValue);
    }

    // eslint-disable-next-line
    updateInnerHTML(el, value) {
        if (!el || value === undefined) return;

        el.innerHTML = value;
    }
}
